import userManager, {
  userManagerConfig,
  B2CLogoutEndpoint,
  InternalViewPolicy,
  GetSignInSignUpPolicy
} from "./UserManagerHelper";
import logoutService from "../services/logoutService";
import { Paths } from "../constants/UrlConstants";

export const B2CSignOut = async ({ isInternalView, exitSurveyType } = {}) => {
  let url = "";
  if (isInternalView) {
    url = B2CLogoutEndpoint(InternalViewPolicy);
  } else {
    url = B2CLogoutEndpoint(GetSignInSignUpPolicy());
  }

  await logoutService();

  userManagerConfig.metadata.end_session_endpoint = url;

  const state = {
    exitSurveyType: exitSurveyType,
    redirectPath: Paths.LoggedOut
  };

  await userManager.signoutRedirect({ state });
};
